import { browserUtils } from '../browser/browser';
import {
  EXTERNAL_LINKS,
  RATE_US_URLS,
} from '../../constants/external/external-links';
import {
  LEGACY_ROUTES,
  QUERY_PARAM_TRUE,
  QUERY_PARAMS,
  ROUTES,
} from '../../constants/app/routes';

export const buildRuleFormRoute = (
  groupId?: string,
  source?: string
): string => {
  const params = new URLSearchParams();
  if (source) {
    params.set(QUERY_PARAMS.SOURCE, source);
  }
  if (groupId) {
    params.set(QUERY_PARAMS.GROUP_ID, groupId);
  } else {
    params.set(QUERY_PARAMS.CREATE_RULE, QUERY_PARAM_TRUE);
  }
  return `${ROUTES.HOME}?${params.toString()}`;
};

export const buildAddItemRoute = (
  groupId?: string,
  source?: string
): string => {
  const params = new URLSearchParams();

  if (source) {
    params.set(QUERY_PARAMS.SOURCE, source);
  }

  if (groupId) {
    params.set(QUERY_PARAMS.ADD_ITEM_MODAL, QUERY_PARAM_TRUE);
    params.set(QUERY_PARAMS.GROUP_ID, groupId);
  }

  const queryString = params.toString();
  // todo: confirm with designer where legacy block sites links should lead in the new app
  return queryString
    ? `${LEGACY_ROUTES.BLOCK_SITES}?${queryString}`
    : LEGACY_ROUTES.BLOCK_SITES;
};

class LinksUtils {
  public getRateUsUrl(): string {
    // TODO:: add other browsers
    if (browserUtils.isEdge()) {
      return RATE_US_URLS.EDGE;
    }
    return RATE_US_URLS.CHROME;
  }

  public getWebsiteIconSrc(domainUrl: string): string {
    return `${EXTERNAL_LINKS.GOOGLE_FAVICON_API}?sz=64&domain_url=${domainUrl}`;
  }
}

export const linksUtils = new LinksUtils();
